<template>
  <div>
    <div
      class="group shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded"
      @click="handleClick"
    >
      <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
        <avatar
          :avatar="office.doctorAvatar"
          :name="office.doctorFirstName + ' ' + office.doctorLastName"
          class="mr-2 w-10 h-10 md:w-12 md:h-12"
        ></avatar>
        <div class="ml-4">
          <div class="flex items-center">
            <!-- <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span> -->
            <span
              class="text-sm md:text-base font-bold"
            >{{ office.doctorFirstName + ' ' + office.doctorLastName }}</span>
          </div>
          <div class="flex items-top md:mt-1">
            <span class="icon mr-2 text-lg text-grey">
              <i class="mdi mdi-map-marker"></i>
            </span>
            <span class="text-sm text-grey font-semi-bold">
              {{ office.name }}
              <br />
              {{ office.zipCode }} {{ office.locality }}
            </span>
          </div>
          <div
            class="tooltip flex md:mt-1 items-center"
            v-if="office.doctorType === 'OSTEOPATH' && office.isDoctorMemberOfOsteopathie"
          >
            <span class="icon mr-2 text-sm text-green">
              <i class="mdi mdi-check-circle"></i>
            </span>
            <span class="text-sm">{{ $t('Member_of_Osteopathie') }}</span>
            <span class="tooltip-text text-sm">{{$t('Oste_tooltip')}}</span>
          </div>
          <div class="flex mb-1">
            <template
              v-if="office.isDoctorRegulated && (office.doctorType !== 'OSTEOPATH' && office.doctorType !== 'PSYCHOLOGIST')"
            >
              <span class="icon mr-2 text-sm text-green">
                <i class="mdi mdi-currency-eur"></i>
              </span>
              <span class="text-sm text-green">{{ $t('Contracted_doctor') }}</span>
            </template>
            <template
              v-if="!office.isDoctorRegulated && (office.doctorType !== 'OSTEOPATH' && office.doctorType !== 'PSYCHOLOGIST')"
            >
              <span class="icon mr-2 text-sm text-red">
                <i class="mdi mdi-currency-eur"></i>
              </span>
              <span class="text-sm text-red">{{ $t('Contracted_doctor_negative') }}</span>
            </template>
          </div>
          <!-- OFFICE SETTINGS -->
            <OfficeSettings
                v-if="office.officeSettings"
                :accessible="office.officeSettings.accessible"
                :card="office.officeSettings.card"
                :cash="office.officeSettings.cash"
            />
            <!-- OFFICE SETTINGS -->
        </div>
      </div>
      <div
        class="transition flex rounded-b bg-grey-light group-hover:bg-blue text-grey-darker group-hover:text-white py-1 justify-center"
      >
        <span
          class="uppercase tracking-wide font-semibold text-sm"
        >{{ $t('See_office_availabilities') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import helpers from "@/mixins/helpers";
import OfficeSettings from '@/components/Patient/OfficeSettings'

export default {
  name: "office-list-item",

  components: {OfficeSettings},

  mixins: [helpers],

  props: ["office"],

  methods: {
    handleClick() {
      this.$router.push({
        name: "office.show",
        params: { id: this.office.id }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Patient/OfficeListItem.vue